import { useState } from 'react';
import { CheckIcon, CopyIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/cn';

export function CodeBlock({
  code,
  language,
  className,
  copyLabel = 'Αντιγραφή',
  copiedLabel = 'Αντιγράφηκε',
}: {
  code: string;
  language?: string;
  className?: string;
  copyLabel?: string;
  copiedLabel?: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div
      className={cn(
        'group relative overflow-hidden rounded-md border border-hairline bg-sunken',
        className,
      )}
    >
      {language && (
        <div className="eyebrow border-b border-hairline px-3.5 py-1.5 text-[0.625rem]">
          {language}
        </div>
      )}
      <pre className="overflow-x-auto p-3.5 font-mono text-[0.8125rem] leading-relaxed text-ink-soft">
        <code>{code}</code>
      </pre>
      <button
        type="button"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
          } catch {
            /* clipboard blocked */
          }
        }}
        className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-sm border border-hairline bg-surface px-2 py-1 text-xs text-ink-muted opacity-0 transition-opacity hover:text-ink focus-visible:opacity-100 group-hover:opacity-100"
      >
        {copied ? (
          <CheckIcon className="size-3.5 text-success" />
        ) : (
          <CopyIcon className="size-3.5" />
        )}
        {copied ? copiedLabel : copyLabel}
      </button>
    </div>
  );
}
